export const SourceComponentType = {
    LOBBY_HEADER: 'Lobby Header',
    LOBBY_EMPTY_VIEW: 'Lobby Empty View',
    AVAILABLE_SERVICES: 'Available Services',
};
